<template>
  <LoginWrapper>
       <div class="tips" >url:{{wxUrl}}</div>
      <div class="tips" >code:{{wxCode}}</div>
    <LoginContent
      v-if="isLogin"
      :school-name="schoolName"
      :user-name="form.userName"
      @login="onLogin"
    />
    <LoginQRCode
      v-else
      ref="qr"
      :user-name="form.userName"
      :detail="visitorRcord"
      @refreshQR="refreshQR"
    />
  </LoginWrapper>
</template>

<script>
import LoginWrapper from "./components/loginWrapper.vue"
import LoginContent from "./components/loginContent.vue"
import LoginQRCode from "./components/loginQRCode.vue"
import { Toast } from "vant"
import { ref, computed, onMounted } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex"
export default {
  components: {
    LoginWrapper,
    LoginContent,
    LoginQRCode,
  },
  setup() {
    const wxCode = ref('c');
    const wxUrl = ref('u');
    const getUrlParam=(name) =>{
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
wxUrl.value = window.location.href
        let url = window.location.href.split('#')[0];
        let search = url.split('?')[1];
        if (search) {
            var r = search.substr(0).match(reg);
            if (r !== null) {
                return unescape(r[2]);
            }
            return null;
        } else {
            return null;
        }
    }

         onMounted(() => {
      const code = getUrlParam('code')  // 截取路径中的code
    wxCode.value=code
    });

    const store = useStore()
    const router = useRouter()

    const navBarThemeVars = ref({
      navBarTextColor: "#fff",
      navBarBackgroundColor: "transparent",
    })

    const isLogin = computed({
      get: () => store.state.isLogin,
      set: (payload) => {
        store.commit("setIsLogin", payload)
      },
    })
    const flagFirstInfo = computed({
      get: () => store.state.flagFirstInfo,
      set: (payload) => {
        store.commit("setFlagFirstInfo", payload)
      },
    })
    const visitorRcord = computed({
      get: () => store.state.visitor.visitorRcord,
      set: (payload) => store.commit("visitor/setVisitorRcord", payload),
    })

    const schoolName = ref(computed(() => store.state.schoolName))

    const form = ref({
      userName: computed({
        get: () => store.state.userName,
        set: (payload) => {
          store.commit("setUserName", payload)
        },
      }),
      schoolCode: computed({
        get: () => store.state.schoolCode,
        set: (payload) => {
          store.commit("setSchoolCode", payload)
        },
      }),
      phone: computed({
        get: () => store.state.phone,
        set: (payload) => {
          store.commit("setPhone", payload)
        },
      }),
      idNumber: computed({
        get: () => store.state.idNumber,
        set: (payload) => {
          store.commit("setIdNumber", payload)
        },
      }),
    })

    const qr = ref(null)

    const openAutoInfo = (params) =>
      store.dispatch("visitor/openAutoInfo", params)
    const openAutoInfoServe = async (params) => {
      let r = await openAutoInfo(params)
      if (r.success && r.data) {
        if (flagFirstInfo.value) {
          flagFirstInfo.value = false
        }

        visitorRcord.value = r.data || {}
        qr.value.refreshStatus(false)
      } else {
        if (flagFirstInfo.value && isHistory.value) {
          flagFirstInfo.value = false
          router.push({
            path: "/visitorRecord",
          })
        }
      }
    }

    const isHistory = ref(false)
    const openCheckHistory = (params) =>
      store.dispatch("visitor/openCheckHistory", params)
    const checkHistory = async () => {
      let { userName, phone, idNumber, schoolCode } = form.value
      if (!schoolCode || !idNumber) {
        isLogin.value = true
        Toast.fail("缺少schoolCode, idNumber参数！")
        return
      }

      let params = {
        userName,
        phone,
        idNumber,
        schoolCode,
      }
      let r = await openCheckHistory(params)
      let { success, data } = r || {}
      if (success && data) {
        isHistory.value = true
        openAutoInfoServe(params)
      } else {
        if (flagFirstInfo.value) {
          flagFirstInfo.value = false
          router.push({
            path: "/visitorApply",
          })
        }
      }
      isLogin.value = false
    }
    const onLogin = (params) => {
      let { userName, phone, idNumber } = params
      form.value.userName = userName
      form.value.phone = phone
      form.value.idNumber = idNumber
      checkHistory()
    }
    if (form.value.schoolCode && form.value.idNumber) {
      checkHistory()
    }

    const refreshQR = (id) => {
      let params = {
        schoolCode: form.value.schoolCode,
        idNumber: form.value.idNumber,
        phone: form.value.phone,
        id,
      }
      openAutoInfoServe(params)
    }
    return {
      schoolName,
      qr,
      navBarThemeVars,
      form,
      isLogin,
      visitorRcord,
      onLogin,
      refreshQR,
      wxCode,
      wxUrl,
      getUrlParam
    }
  },
}
</script>

<style lang="less" scoped>
.login-wrapper {
  .tips {
    font-size: 20px;
    color: red;
  }
  .login-content {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>
